import Vue from 'vue'
import Router from 'vue-router'
import Home from './pages/Home';
let About =()=>import('./pages/About')
let News =()=>import('./pages/News')
let NewsDetail =()=>import('./pages/NewsDetail')
let Cases =()=>import('./pages/Cases')
let CasesDetail =()=>import('./pages/CasesDetail')

let Social =()=>import('./pages/Social')




let Investment =()=>import('./pages/Investment')









Vue.use(Router)

let routes= [
      {
        path: '/',
        name: 'home',
        component: Home,
        meta: {
          title: '首页'
        }
      
      },
      {
        path: '/about',
        name: 'About',
        component: About,
        meta: {
          title: '公司简介'
        }
      
      },
      {
        path: '/news',
        name: 'News',
        component: News,
        meta: {
          title: '新闻中心'
        }
      
      },
      {
        path: '/newsdetail/:id',
        name: 'NewsDetail',
        component: NewsDetail,
        meta: {
          title: '新闻中心'
        }
      
      },
      // Cases
      {
        path: '/cases',
        name: 'Cases',
        component: Cases,
        meta: {
          title: '成功案例'
        }
      
      },
      {
        path: '/casesdetail/:id',
        name: 'CasesDetail',
        component: CasesDetail,
        meta: {
          title: '成功案例'
        }
      
      },
      {
        path: '/social',
        name: 'Social',
        component: Social,
        meta: {
          title: '解决方案'
        }
      
      },
    

      {
        path: '/investment',
        name: 'Investment',
        component: Investment,
        meta: {
          title: '招商加盟'
        }
      
      },
      



      {
        path:'*',
        redirect:{name:'home'}
      }
]

export default new Router({
    // mode: 'history',
    base: process.env.BASE_URL,
   
    
    routes
  })